// Api.js
import axios from 'axios';
import { BACKEND_BASE_URL } from "../constants/constants";

const instance = axios.create({
    baseURL: BACKEND_BASE_URL,
});

export const get = (path, params) => instance.get(path, { params });
export const post = (path, data) => instance.post(path, data);
export const put = (path, data) => instance.put(path, data);
export const del = (path, data) => instance.delete(path, { data });

